// extracted by mini-css-extract-plugin
module.exports = {"container":"GridGrid_container__MnRCJ","cols-1":"GridGrid_cols-1__i20yl","cols-2":"GridGrid_cols-2__NBfwc","cols-3":"GridGrid_cols-3___D1dX","cols-4":"GridGrid_cols-4__meB3O"};